export default __webpack_public_path__ + "static/media/bnr6.f089f514.jpg";